<template>
  <div id="socDetailChart">
    <el-table :data="titleList" border fit highlight-current-row background="white">
      <el-table-column :label="$t('socDetailPage.device')" align="center">
        <template slot-scope="scope" align="left">
          <span>{{ scope.row.deviceName }}</span><br>
          <span>{{ scope.row.mcuId }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('AllDevices.startDate')" align="center">
        <template slot-scope="scope">
          <el-date-picker
            v-model="obj.startDate"
            type="datetime"
            size="mini"
            :clearable="false"
            value-format="timestamp"
            :placeholder="$t('AllDevices.startDate')"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('AllDevices.endDate')" align="center">
        <template slot-scope="scope">
          <el-date-picker
            v-model="obj.endDate"
            type="datetime"
            size="mini"
            :clearable="false"
            value-format="timestamp"
            :placeholder="$t('AllDevices.endDate')"
          />
        </template>
      </el-table-column>
      <el-table-column :label="$t('socDetailPage.NominalCapacity')" align="center">
        <template slot-scope="scope">
          <el-input v-model="obj.capacity" clearable class="input-with-select" />
        </template>
      </el-table-column>

      <el-table-column label="" align="center">
        <template slot-scope="scope">
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="queryList" />
        </template>
      </el-table-column>
    </el-table>
    <el-tabs v-model="activeDevice" style="margin-top:15px;" type="border-card">
      <el-tab-pane label="Discharged" name="Discharged" style="position:relative;">
        <pointChart :height="height" :width="width" :series-data="seriesDischargedData" :battery-capacity="batteryCapacity1" style="background: white;margin-top:10px;position:relative;" />
      </el-tab-pane>
      <el-tab-pane label="Charged" name="Charged" style="position:relative;">
        <pointChart1 :height="height" :width="width" :series-data="seriesChargedData" :battery-capacity="batteryCapacity1" style="background: white;margin-top:10px;position:relative;" />
      </el-tab-pane>
    </el-tabs>
    <div style="line-height: 25px;background:#fff;padding: 10px 40px 20px;">
      <div style="border-top: 1px dashed #dce2eb;padding-top: 10px;">
        <div>{{ $t('socDetailPage.Note') }}</div>
        <div v-if="activeDevice=='Discharged'">
          <p>1) {{ $t('socDetailPage.Note1') }}</p>
          <p>2)  {{ $t('socDetailPage.Note2') }}</p>
          <p><span style="display: inline-block;width: 20px;" />{{ $t('socDetailPage.Note3') }}</p>
          <p><span style="display: inline-block;width: 20px;" />{{ $t('socDetailPage.Note4') }}</p>
        </div>
        <div v-else>
          <p>1) {{ $t('socDetailPage.Note5') }}</p>
          <p>2)  {{ $t('socDetailPage.Note6') }}</p>
          <p><span style="display: inline-block;width: 20px;" />{{ $t('socDetailPage.Note7') }}</p>
          <p><span style="display: inline-block;width: 20px;" />{{ $t('socDetailPage.Note8') }}</p>
        </div>
      </div>
    </div>
    <!-- <el-dialog :close-on-click-modal="false" :title="$t('socDetailPage.Tips')" :visible.sync="dialogVisible" width="30%">
      <span>{{ $t('socDetailPage.NoRecord') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ $t('button.Confirm') }}</el-button>
      </span>
    </el-dialog> -->
  </div>

</template>

<script>
import pointChart from '@/components/pointChart'
import pointChart1 from '@/components/pointChart1'
import { listDischarging, bmsListDischarging, listCharging, bmsListCharging, findDeviceInfo } from '@/api/allDevice'

export default {
  components: {
    pointChart,
    pointChart1
  },
  data() {
    this.apiproto
    this.protobuf
    return {
      height: '600px',
      width: '100%',
      seriesDischargedData: [],
      seriesChargedData: [],
      batteryCapacity1: 0,
      titleList: [],
      dialogVisible: false,
      deviceName: this.$route.query.deviceName,
      obj: {
        showAll: false,
        capacity: 100,
        endDate: new Date(Number(this.$route.query.lastUpdateTime)).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1,
        mcuId: this.$route.query.mcuId,
        startDate: new Date(Number(this.$route.query.lastUpdateTime)).setHours(0, 0, 0, 0) - 1000 * 60 * 60 * 24 * 6
        // endDate: '1571931819284', // 假数据
        // mcuId: '05d5ff333332534e43205755',
        // startDate: '1571365140000'
      },
      activeDevice: 'Discharged'
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      var oldValue1 = [...this.seriesDischargedData]
      this.seriesDischargedData = []
      this.seriesDischargedData = oldValue1
      var oldValue2 = [...this.seriesChargedData]
      this.seriesChargedData = []
      this.seriesChargedData = oldValue2
    },
    activeDevice() {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
        // console.log('triggerResize--', triggerResize)
      }, 0)
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    this.titleList[0] = {
      deviceName: this.$route.query.deviceName,
      mcuId: this.$route.query.mcuId
    }
    this.queryList()
    this.init()
  },
  methods: {
    queryList() {
      var capacityS = this.obj.capacity || 100
      if (this.$route.query.deviceType == 'Yhub') {
        listDischarging(this.obj).then(res => {
          if (res.resultCode == 1001) {
            this.seriesDischargedData = []
            if (res.resultModel.length > 0) {
              res.resultModel.forEach(v => {
                this.seriesDischargedData.push([((v.socDifference / 100) * capacityS).toFixed(2), v.useAhDifference, v.actionTime])
              })
              // this.seriesDischargedData.push([1.3, 2.5, 1571931819284])//假数据
              // this.seriesDischargedData.push([3.2, 1.5, 1571931819284])
              // this.seriesDischargedData.push([0.3, 2.8, 1571931819284])
            } else {
              this.dialogVisible = true
            }
          }
        })
        listCharging(this.obj).then(res => {
          if (res.resultCode == 1001) {
            this.seriesChargedData = []
            if (res.resultModel.length > 0) {
              res.resultModel.forEach(v => {
                this.seriesChargedData.push([((v.chargingSocDifference / 100) * capacityS).toFixed(2), v.chargingAhDifference, v.actionTime])
              })
              // this.seriesDischargedData.push([1.3, 2.5, 1571931819284])//假数据
              // this.seriesDischargedData.push([3.2, 1.5, 1571931819284])
              // this.seriesDischargedData.push([0.3, 2.8, 1571931819284])
            } else {
              this.dialogVisible = true
            }
          }
        })
      } else if (this.$route.query.deviceType == 'Lithium') {
        bmsListDischarging(this.obj).then(res => {
          if (res.resultCode == 1001) {
            this.seriesDischargedData = []
            if (res.resultModel.length > 0) {
              res.resultModel.forEach(v => {
                this.seriesDischargedData.push([((v.socDifference / 100) * capacityS).toFixed(2), v.useAhDifference, v.actionTime])
              })
            } else {
              this.dialogVisible = true
            }
          }
        })
        bmsListCharging(this.obj).then(res => {
          if (res.resultCode == 1001) {
            this.seriesChargedData = []
            if (res.resultModel.length > 0) {
              res.resultModel.forEach(v => {
                this.seriesChargedData.push([((v.chargingSocDifference / 100) * capacityS).toFixed(2), v.chargingAhDifference, v.actionTime])
              })
            } else {
              this.dialogVisible = true
            }
          }
        })
      }
    },
    init() {
      findDeviceInfo({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (res.resultModel) this.batteryCapacity1 = res.resultModel.batteryCapacity
        }
      })
    }
  }
}

</script>
<style lang="scss">
#socDetailChart{
  .el-tabs--border-card {
    border: none;
    box-shadow: none;
  }
}
</style>
